"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6191],{

/***/ 6191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ArticleSection_ArticleSection; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../wif-ui-lib/dist/ArticleSection.js
var ArticleSection = __webpack_require__(2579);
;// CONCATENATED MODULE: ./src/magnolia/components/ArticleSection/ArticleSection.tsx



var HtmlParser = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4288).then(__webpack_require__.bind(__webpack_require__, 4288));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4288)
            ];
        }
    }
});
function ArticleSection_ArticleSection(param) {
    var heading = param.heading, anchorTag = param.anchorTag, subHeading = param.subHeading, bodyText = param.bodyText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleSection/* ArticleSection */.F, {
        heading: heading,
        id: anchorTag,
        subHeading: subHeading,
        bodyText: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlParser, {
            html: bodyText
        })
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/ArticleSection/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 2579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ P; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3406);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4877);



const l = "section", _ = "section__content", C = "block__content", b = "mobile", u = "desktop", g = "section__content__component", x = "section__content__component__title", T = "section__content__description", D = "section__content__description__footer", E = "section__content__description__body-text", y = "section__content__description__sub-heading", e = {
  section: l,
  sectionContent: _,
  blockContent: C,
  mobile: b,
  desktop: u,
  sectionContentComponent: g,
  sectionContentComponentTitle: x,
  sectionContentDescription: T,
  sectionContentDescriptionFooter: D,
  sectionContentDescriptionBodyText: E,
  sectionContentDescriptionSubHeading: y
};
function h({ content: n }) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "h2",
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsComponentTitleBold,
        e.sectionContentComponentTitle
      ),
      itemProp: "name"
    },
    n
  );
}
function N({ content: n }) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "h3",
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsParagraphSubtitleBold,
        e.sectionContentDescriptionSubHeading
      ),
      itemProp: "name"
    },
    n
  );
}
function S(n) {
  const { content: r, isFooterSection: o } = n;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.sectionContentDescriptionBodyText, {
        [_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsLeadText]: o,
        [_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.richText]: o,
        [_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsBodyText]: !o
      }),
      itemProp: "description"
    },
    r
  );
}
function P(n) {
  const { id: r, heading: o, subHeading: a, bodyText: m, isFooterSection: d } = n, p = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    e.sectionContentDescription,
    d ? e.sectionContentDescriptionFooter : ""
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B,
    {
      as: "section",
      id: r,
      topPadding: o ? _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.SMALL : _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.NONE,
      bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.LARGE,
      className: e.section,
      "data-testid": "article-section-block"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Content,
      {
        className: e.sectionContent,
        "data-testid": "article-section-block-content",
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      o && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("article", { className: e.sectionContentComponent }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(h, { content: o })),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "article",
        {
          className: p,
          "data-testid": "article-section-content-description"
        },
        a && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(N, { content: a }),
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(S, { isFooterSection: d, content: m })
      )
    )
  );
}

//# sourceMappingURL=ArticleSection.js.map


/***/ })

}]);